// When a member removes themself from a group signup, each remaining registration
// keeps its existing paying member. Only registrations the leaving member was paying
// for are reassigned to the signup owner. (ENG-2126)
//
// Previously every remaining registration was collapsed onto the first remaining
// member, which silently moved self-paying members onto the owner.
export function resolveRemovalPayer(
  currentPayingMemberId: string | undefined,
  removedMemberId: string | undefined,
  ownerMemberId: string | null
): string | null {
  return currentPayingMemberId === removedMemberId
    ? ownerMemberId
    : currentPayingMemberId ?? null;
}
